import { render, staticRenderFns } from "./TemperatureViolations.vue?vue&type=template&id=6ff16cbc&scoped=true&"
import script from "./TemperatureViolations.vue?vue&type=script&lang=js&"
export * from "./TemperatureViolations.vue?vue&type=script&lang=js&"
import style0 from "./TemperatureViolations.vue?vue&type=style&index=0&id=6ff16cbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff16cbc",
  null
  
)

export default component.exports